import { MultiSlideCarousel } from "components/carousel/multiSlide";
import Image from "components/imageNew/image";
import { FullDatoImage } from "lib/types/datoBlocks";
import classNames from "classnames";

type CarouselProps = {
  slides: FullDatoImage[];
};

export const Carousel = ({ slides }: CarouselProps) => {
  if (!slides.length) return null;

  const slidesMulti = slides.map((image, i) => {
    return {
      widths: [430, 520, 320],
      component: (
        <Image
          key={i}
          src={image?.url}
          alt={image?.alt}
          height={image?.height}
          width={image?.width}
          blurDataURL={image?.blurUpThumb || undefined}
          className={classNames(
            "pointer-events-none mx-auto object-cover object-center",
            "h-100 min-h-[214px] w-[320px] md:min-h-[348px] md:w-[520px] lg:min-h-[290px] lg:w-[430px]"
          )}
        />
      ),
    };
  });

  return (
    <div className="-mx-5 max-h-fit lg:mx-0" data-testid={"carousel"}>
      <MultiSlideCarousel
        autoplay={false}
        belowSlides="prevNext"
        slides={slidesMulti}
        containerClasses="h-[215px] md:h-[348px] lg:h-[290px]"
        slideClasses="h-100"
        paginationContainerClassesOverride="mt-[20px] md:mt-[30px] flex justify-center"
        responsiveGap={[30, 36, 12]}
        onlyCenterInteractive={true}
      />
    </div>
  );
};

export default Carousel;
